
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Breadcrumb } from "@components/breadcrumb";
import { CompanyLogo } from "@components/company-logo";
import { Products } from "@components/products";
import { NextSeo } from "@components/seo";
import { PVC } from "@consts/ppvc";
import type { ICompany } from "@type/company";
import type { IProduct } from "@type/products";
import { getAllPvcByParent } from "@utils/get-products";
import type { GetStaticProps, NextPage } from "next/types";
import useTranslation from "next-translate/useTranslation";
interface ICompanyCard {
    company: ICompany;
    products: IProduct[];
}
const PvcDecco: NextPage<ICompanyCard> = ({ products, company }) => {
    const { t } = useTranslation("common");
    return (<>
      <NextSeo languageAlternates={[
            {
                href: "https://knsokna.pl/pvc/sliding-doors/veka",
                hrefLang: "x-default",
            },
            {
                href: "https://knswindows.com/pvc/sliding-doors/veka",
                hrefLang: "en",
            },
            { href: "https://knsokna.pl/pvc/sliding-doors/veka", hrefLang: "pl" },
            {
                href: "https://knsfenster.de/pvc/sliding-doors/veka",
                hrefLang: "de",
            },
            {
                href: "https://kns-okna.eu/pvc/sliding-doors/veka",
                hrefLang: "cs",
            },
            {
                href: "https://knsfinestre.it/pvc/sliding-doors/veka",
                hrefLang: "it",
            },
            {
                href: "https://knsfenetres.fr/pvc/sliding-doors/veka",
                hrefLang: "fr",
            },
            { href: "https://knsokna.eu/pvc/sliding-doors/veka", hrefLang: "hu" },
        ]}/>
      <div className="bg-white">
        <div className="mx-auto max-w-7xl px-4 py-2 sm:px-6 lg:px-8">
          <Breadcrumb />
          <h1 className="bg-gradient-to-r from-red to-orange p-1 font-bold text-3xl text-white">
            {company?.title}
          </h1>
          <CompanyLogo content={company?.content} logo="Veka" title={company?.title}/>
          {t("menu.products")}:
          <br />
          <Products products={products} showId/>
          <hr />
        </div>
      </div>
    </>);
};
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || "PL";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const { products, company } = await getAllPvcByParent(PVC.SLIDING_DOORS.VEKA[LOCALE as keyof typeof PVC.SLIDING_DOORS.VEKA], LOCALE);
    return {
        props: {
            company,
            products,
        },
    };
};
export default PvcDecco;

    async function __Next_Translate__getStaticProps__1a19cd2c090__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/pvc/sliding-doors/veka/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2c090__ as getStaticProps }
  